import React from "react";

export const SYNC_STATUSES = ["Linked", "Suggested Match", "Not Linked", "Not Billed in Xero", "Sync Error"];
const CLS = {
  Linked: "border-[var(--ok)] text-[var(--ok)] bg-[var(--ok-bg)]",
  "Suggested Match": "border-[var(--warn)] text-[var(--warn)] bg-[var(--gold-soft)]",
  "Not Linked": "border-[var(--line)] text-[var(--ink-2)]",
  "Not Billed in Xero": "border-[var(--navy)] text-[var(--navy)] bg-[var(--navy-soft)]",
  "Sync Error": "border-[var(--err)] text-[var(--err)] bg-[var(--err-bg)]",
};

export function SyncStatusPill({ status, testid }) {
  if (!status) return <span>—</span>;
  return <span data-testid={testid} className={`status-pill whitespace-nowrap ${CLS[status] || ""}`}>{status}</span>;
}
